import React from "react";
import "./styles.scss";

import logoWhite from "../../assets/logo-mockup.svg";
import logoColor from "../../assets/logo-color.svg";

function Logo({ color, size }) {
  return (
    <div className={`logo--wrapper ${size}`}>
      <img src={color ? logoColor : logoWhite} alt="Logo Giga Storage" />
    </div>
  );
}

export default Logo;
